module.exports = __webpack_public_path__ + "static/media/FabDeliveryNew.26699347.svg";